export default __webpack_public_path__ + "images/flight_in.47e9ede.png";